import { render, staticRenderFns } from "./SundryItemStockList.vue?vue&type=template&id=2a382a3a&scoped=true&"
import script from "./SundryItemStockList.vue?vue&type=script&lang=js&"
export * from "./SundryItemStockList.vue?vue&type=script&lang=js&"
import style0 from "./SundryItemStockList.vue?vue&type=style&index=0&id=2a382a3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a382a3a",
  null
  
)

export default component.exports